module.exports = "<svg fill=#000000 height=24 viewBox=\"0 0 24 24\" width=24 xmlns=http://www.w3.org/2000/svg> <path d=\"M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z\"/> <path d=\"M0 0h24v24H0z\" fill=none /> </svg>";


//////////////////
// WEBPACK FOOTER
// ../~/html-loader!../~/@printos/gazelle/src/mini-apps/app-switcher/icons/press-security.svg
// module id = 210
// module chunks = 0